import { nextTick } from "vue";
import { IsResponseDataValid } from "../_helpers/ui/helpers";
import { UserService } from "../_services/api/settings/user/user.service";
import ReportService from "../_services/api/templates/report.service";
import { CommonStorage } from "../_services/storage";

import DataGridHelpers from "@/_helpers/data-grid/helpers";
const { syncDateFilters } = DataGridHelpers;
import { store } from "@/_store";

import {
    getGlobalField
} from "@/_store/helpers";

const DataGridState = {
    isAvailable(key) {
        if (CommonStorage.getItems(key)) return true;
        // if (localStorage.getItem(key)) return true;
        else return false;
    },

    // async readStoredState(key, dbResponse) {

    //     let cashResponse = JSON.parse(
    //         CommonStorage.getItems(key)
    //     );

    //     if (cashResponse.searchText) CommonStorage.saveItems('searchText', cashResponse.searchText);

    //     dbResponse.columns.forEach((db) => {
    //         cashResponse.columns.forEach((store) => {
    //             // console.log('X1 ', getGlobalField(db.screenField));
    //             if (store.dataField == db.screenField || store.dataField == db.gridDataField || (store.dataField == getGlobalField(db.screenField).dataField || store.dataField == getGlobalField(db.screenField).gridDataField)) {
    //                 if (store.hasOwnProperty("groupIndex")) {
    //                     db.groupIndex = store.groupIndex;
    //                 } else db.groupIndex = undefined;
    //                 if (store.hasOwnProperty("visibleIndex")) {
    //                     db.visibleIndex = store.visibleIndex;
    //                 } else db.visibleIndex = undefined;
    //                 if (store.hasOwnProperty("sortOrder")) {
    //                     db.sortOrder = store.sortOrder;
    //                 } else db.sortOrder = undefined;
    //                 if (store.hasOwnProperty("sortIndex")) {
    //                     db.sortIndex = store.sortIndex;
    //                 } else db.sortIndex = undefined;
    //                 if (store.hasOwnProperty("visible")) {
    //                     db.visible = store.visible;
    //                 } else db.visible = false;

    //                 if (store.dataField == 'ProductDescription1') console.log('++++ ', db);
    //             } else {
    //                 // db.groupIndex = db.visibleIndex = db.sortOrder = db.sortIndex = undefined;
    //             }
    //         });

    //         var dataField = db.screenField

    //         if (db.gridDataField) dataField = db.gridDataField;
    //         else if (getGlobalField(db.screenField).gridDataField) dataField = getGlobalField(db.screenField).gridDataField;
    //         else if (getGlobalField(db.screenField).dataField) dataField = getGlobalField(db.screenField).dataField;
    //         else dataField = db.screenField;


    //         var label = db.screenField;

    //         if (db.gridLabel) label = db.gridLabel;
    //         else if (getGlobalField(db.screenField).gridLabel) label = getGlobalField(db.screenField).gridLabel;
    //         else if (getGlobalField(db.screenField).label) label = getGlobalField(db.screenField).label;




    //         // console.log('XX ', db.screenField , dataField , cashResponse.columns.findIndex((x) => x.dataField == dataField));
    //         console.log('XX ', db.screenField, dataField, label);

    //         if (db.screenField == 'Product') {
    //             cashResponse.columns.forEach(element => {
    //                 if (element.dataField == dataField) {
    //                     console.log('S1 ', element, db);
    //                 }
    //             });
    //         }


    //         if (
    //             CommonStorage.getItems("filter-panel-" + key) !== null
    //         ) {
    //             let filtercashResponse = JSON.parse(
    //                 CommonStorage.getItems("filter-panel-" + key)
    //             );

    //             if (db.hasOwnProperty("filterDefaultValue")) {
    //                 db.filterDefaultValue = new Array();
    //             }
    //             filtercashResponse.forEach((filterstore) => {
    //                 if (filterstore != "and") {
    //                     filterstore.forEach((filterstore1) => {
    //                         console.log('X2 ', filterstore1[0], getGlobalField(db.screenField));
    //                         if (filterstore1[0] == db.screenField || filterstore1[0] == db.filterDataField || filterstore1[0] == getGlobalField(db.screenField).dataField) {

    //                             // console.log('A1', filterstore1[2])

    //                             if (filterstore1[2].toString().match(/^[+-]?\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])/) == null) {
    //                                 if (db.filterDefaultValue === undefined) {
    //                                     db.filterDefaultValue = new Array(filterstore1[2]);
    //                                 } else {
    //                                     db.filterDefaultValue.push(filterstore1[2]);
    //                                 }
    //                             } else {

    //                                 console.log('XXX ', db.filterDefaultValue);

    //                                 if (filterstore1[1] == '>=' && filterstore.length == 3) {

    //                                     if ((new Date(filterstore[2][2]) - new Date(filterstore[0][2])) / (1000 * 60 * 60 * 24) == 1) {
    //                                         db.filterDefaultValue = new Date(filterstore1[2]).addGMTHours(0, 0);
    //                                         db.filterOperator = "=";
    //                                     } else {
    //                                         db.filterDefaultValue = { from: new Date(filterstore[0][2]), to: new Date(filterstore[2][2].replace('Z', '')) }
    //                                         db.filterOperator = "between";
    //                                     }

    //                                 } else if (filterstore1[1] == '<' && filterstore.length == 1) {
    //                                     db.filterOperator = "<";

    //                                     db.filterDefaultValue = new Date(filterstore1[2]);
    //                                 } else if (filterstore1[1] == '>' && filterstore.length == 1) {
    //                                     db.filterOperator = ">";

    //                                     db.filterDefaultValue = new Date(filterstore1[2]);
    //                                 } else if (filterstore1[1] == '<=' && filterstore.length == 1) {
    //                                     db.filterOperator = "<=";

    //                                     db.filterDefaultValue = new Date(filterstore1[2]);
    //                                 }
    //                                 else if (filterstore1[1] == '>=' && filterstore.length == 1) {
    //                                     db.filterOperator = ">=";

    //                                     db.filterDefaultValue = new Date(filterstore1[2]);
    //                                 } //else db.filterDefaultValue = undefined;
    //                             }
    //                         }
    //                     });
    //                 }
    //             });
    //         }
    //     });

    //     dbResponse.columns.sort(function (a, b) {
    //         return a.visibleIndex - b.visibleIndex;
    //     });

    //     return dbResponse;
    // },

    getColumns(key, dbResponse) {
        let cashResponse = JSON.parse(CommonStorage.getItems(key));
        // if (cashResponse.searchText) CommonStorage.saveItems('searchText', cashResponse.searchText);

        dbResponse.forEach(db => {
            var index = cashResponse.columns.findIndex((x) => x.dataField == db.dataField && x.name == db.caption);

            if (index > -1) {
                var store = cashResponse.columns[index];
                if (store.hasOwnProperty("groupIndex")) {
                    db.groupIndex = store.groupIndex;
                } else db.groupIndex = undefined;
                if (store.hasOwnProperty("visibleIndex")) {
                    db.visibleIndex = store.visibleIndex;
                } else db.visibleIndex = undefined;
                if (store.hasOwnProperty("sortOrder")) {
                    db.sortOrder = store.sortOrder;
                } else db.sortOrder = undefined;
                if (store.hasOwnProperty("sortIndex")) {
                    db.sortIndex = store.sortIndex;
                } else db.sortIndex = undefined;
                if (store.hasOwnProperty("visible")) {
                    db.visible = store.visible;
                } else db.visible = false;

            }

        });

        dbResponse.sort(function (a, b) {
            return a.visibleIndex - b.visibleIndex;
        });

        return dbResponse;
    },
    setSearchText(key) {

        if (!CommonStorage.getItems(key)) return true;
        else {
            let cashResponse = JSON.parse(CommonStorage.getItems(key));
            if (cashResponse.searchText) {
                CommonStorage.saveItems('searchText', cashResponse.searchText);
            } else CommonStorage.clear('searchText');
        }
    },
    setFilterData(key, items) {
        if (!CommonStorage.getItems(key)) return items;
        else {
            if (CommonStorage.getItems("filter-panel-" + key) !== null) {
                let filtercashResponse = JSON.parse(CommonStorage.getItems("filter-panel-" + key));

                items.forEach(db => {
                    if (db.hasOwnProperty("filterDefaultValue")) {
                        db.filterDefaultValue = new Array();
                    }
                    filtercashResponse.forEach((filterstore) => {
                        if (filterstore != "and") {
                            filterstore.forEach((filterstore1) => {
                                if (db.filterDataRelationship === "Child" && db.filterDataField && db.filterDataField.includes("/")) {
                                    const match = filterstore1[0].toString().match(/eq\s+'([^']+)'/);
                                    if (match && match[1]) {
                                        if (db.filterDefaultValue === undefined) {
                                            db.filterDefaultValue = new Array();
                                        }
                                        db.filterDefaultValue.push(match[1]);
                                    }
                                }
                                const globalField = getGlobalField(db.screenField);
                                const regex = /^,.*,$/;
                                if (filterstore1[0] == db.screenField || filterstore1[0] == db.filterDataField || (!db.filterDataField && globalField && filterstore1[0] == globalField.dataField)) {

                                    // if (filterstore1[0] == db.dataField) {

                                    if (filterstore1[2].toString().match(/^[+-]?\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])/) == null && filterstore1[2] != null) {

                                        if ((db.type == 'Integer' || db.type == 'Text') || (db.filterIndex != undefined && db.filterIndex > -1 && globalField && (globalField.type == 'Integer'))) {
                                            if (db.filterDataRelationship === "Comma" && regex.test(filterstore1[2])) filterstore1[2] = parseInt(filterstore1[2].replace(/^,|,$/g, ""));
                                            db.filterDefaultValue = null;
                                        }
                                        else if (db.filterDefaultValue === undefined) {
                                            db.filterDefaultValue = new Array();
                                        }
                                        if (filterstore1[1] == '<>' || filterstore1[1] == '<' || filterstore1[1] == '>' || filterstore1[1] == '<=' || filterstore1[1] == '>=') {
                                            if (filterstore.length == 3) {
                                                db.filterDefaultValue = { from: filterstore[0][2], to: filterstore[2][2] }
                                                db.filterOperator = "between";
                                            } else {
                                                db.filterOperator = filterstore1[1];
                                                db.filterDefaultValue = filterstore1[2];
                                            }
                                        } else {
                                            if (db.isYesNo) {
                                                db.filterDefaultValue = filterstore1[2] == "Y" ? true : false;
                                            }
                                            else if (Array.isArray(db.filterDefaultValue)) {

                                                let value = filterstore1[2];
                                                if (db.filterDataRelationship === "Comma" && regex.test(value)) value = value.replace(/^,|,$/g, "");
                                                db.filterDefaultValue.push(value);
                                            }
                                            else {
                                                db.filterDefaultValue = filterstore1[2];
                                            }


                                            if (db.isYesNo !== true && (filterstore1[1] == '=' || filterstore1[1] == 'startswith' || filterstore1[1] == 'contains' || filterstore1[1] == 'endswith')) {
                                                db.filterOperator = filterstore1[1];
                                            }

                                        }
                                    } else {
                                        if (filterstore1[2] == null) return;

                                        if (filterstore1[1] == '>=' && filterstore.length == 3) {

                                            if ((new Date(filterstore[2][2]) - new Date(filterstore[0][2])) / (1000 * 60 * 60 * 24) == 1) {
                                                db.filterDefaultValue = new Date(filterstore1[2]).addGMTHours(0, 0);
                                                db.filterOperator = "=";
                                            } else {
                                                db.filterDefaultValue = { from: new Date(filterstore[0][2]), to: new Date(filterstore[2][2].replace('Z', '')) }
                                                db.filterOperator = "between";
                                            }

                                        } else if (filterstore1[1] == '<' && filterstore.length == 1) {
                                            db.filterOperator = "<";

                                            db.filterDefaultValue = new Date(filterstore1[2]);
                                        } else if (filterstore1[1] == '>' && filterstore.length == 1) {
                                            db.filterOperator = ">";

                                            db.filterDefaultValue = new Date(filterstore1[2]);
                                        } else if (filterstore1[1] == '<=' && filterstore.length == 1) {
                                            db.filterOperator = "<=";

                                            db.filterDefaultValue = new Date(filterstore1[2]);
                                        }
                                        else if (filterstore1[1] == '>=' && filterstore.length == 1) {
                                            db.filterOperator = ">=";

                                            db.filterDefaultValue = new Date(filterstore1[2]);
                                        } // else db.filterDefaultValue = undefined;
                                    }
                                }
                            });
                        }
                    });

                    if (db.hasOwnProperty("filterDefaultValue") && db.filterDefaultValue.length == 0) db.filterDefaultValue = undefined;

                });

            }

            return items;
        }
    },
    getSearchText() {
        return CommonStorage.getItems('searchText');
    },

    async initializeGridViewDefinition(key, originalColumns) {
        if (key) {
            await store.dispatch("gridViewDefinition/setOriginalColumns", {
                key,
                columns: originalColumns,
            });


            nextTick(async () => {
                await store.dispatch(
                    "gridViewDefinition/setGridViewDefinition",
                    key,
                );
            });


        }
    },

    async removeState(key) {
        // eslint-disable-next-line no-console
        console.log("Removing state with key: " + key);
        CommonStorage.clear(key);
        CommonStorage.clear("filter-panel-" + key);
        // TO DO - NEXT - Remove from database

        let savedSelected = CommonStorage.getItems(
            "Selected-viewDefinitions",
        );

        if (savedSelected) {
            savedSelected = JSON.parse(savedSelected);
        } else {
            savedSelected = {};
        }

        if (savedSelected[key]) {
            delete savedSelected[key];
            CommonStorage.saveItems(
                "Selected-viewDefinitions",
                JSON.stringify(savedSelected),
            );
        }

        // Only clear the RecordID from storage after the API call is successful, to avoid losing the reference to the database entry in case of an error
        // CommonStorage.clear(key + "-RecordID");
    },

    // FROM POC - NOT IN USE
    // this function retrevies data from data database using the key and saves it to local storage, so that it can be used to set the state of the grid and filters when the user accesses the grid
    /*
    @param {string} key - The unique identifier for the grid state to be retrieved from the database and saved to local storage
    */
    async checkInDatabase(key) {
        try {
            const response = await ReportService.getViewVariant(key);
            if (IsResponseDataValid(response)) {
                const dbResponse = response.data.value[0];
                if (dbResponse) {
                    const Definition = JSON.parse(dbResponse.Definition);
                    if (Definition) {
                        CommonStorage.saveItems(key, JSON.stringify(Definition));
                        CommonStorage.saveItems(key + "-RecordID", dbResponse.RecordID);
                    }

                    if (dbResponse.FilterDefinition) {
                        const FilterDefinition = JSON.parse(dbResponse.FilterDefinition);
                        if (FilterDefinition) {
                            CommonStorage.saveItems("filter-panel-" + key, JSON.stringify(FilterDefinition));
                        }
                    }
                }
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('DB Error Reading REPORT', error);
        }
    },

    /*
    This function is responsible for saving the current state of the grid and filters to the database. 
    It retrieves the current filter settings from local storage, processes any date filters to ensure they are in the correct format, 
    and then constructs a payload to be sent to the database for saving. 
    The function also handles both creating new entries and updating existing entries in the database based on whether a RecordID already exists for the given key.
    @param {string} Key - The unique identifier for the grid state to be saved to the database
    @param {string} Name - The name of the template or view being saved, which may be used for display purposes in the application
    @param {string} TemplateType - The type of template being saved (e.g., "Grid", "Filter"), which may be used to categorize the saved state in the database
    @param {string} SaveType - Indicates whether this is a new save ("New") or an update to an existing save ("Update"), which determines whether a new entry is created in the database or an existing entry is updated
    @param {array} originalColumns - An array of the original column definitions for the grid, which may be needed for processing date filters and ensuring that they are correctly formatted before saving to the database 
    @param {string|null} RecordID - The unique identifier for the existing record in the database, if updating an existing entry
    */
    async saveStateAndFilterToDatabase(Key, Name, TemplateType, SaveType = "New", originalColumns = [], RecordID = null, IsDefault = 'N') {

        // find out if any of the original columns contains 'filterDefaultValue' value
        const defaultColumn = originalColumns.find(col => col.filterDefaultValue);

        let savedFilters = CommonStorage.getItems("filter-panel-" + Key) ? JSON.parse(CommonStorage.getItems("filter-panel-" + Key)) : null;
        if (savedFilters) {
            const columns = originalColumns;
            savedFilters = syncDateFilters([...savedFilters], columns);
        }

        let GridDefinition = CommonStorage.getItems(Key) ? CommonStorage.getItems(Key) : null;

        // Save Type is 'New' and GridDefinition is emplty, this need to wait and recheck for GridDefinition
        if (SaveType === "New" && !GridDefinition) {
            let attempts = 0;
            const maxAttempts = 5;
            const delay = 1000; // 1 second

            while (attempts < maxAttempts) {
                await new Promise(resolve => setTimeout(resolve, delay));
                GridDefinition = CommonStorage.getItems(Key) ? CommonStorage.getItems(Key) : null;
                if (GridDefinition) {
                    break;
                }
                attempts++;
            }
        }

        // if defaultColumn exists and has filterDefaultValue, we need to ensure that the GridDefinition contains the correct filterDefaultValue for that column before saving to the database
        // this needs to wait and recheck for savedFilters
        if (defaultColumn && defaultColumn.filterDefaultValue && !savedFilters && SaveType === "New" && Name === "Default") {
            let attempts = 0;
            const maxAttempts = 5;
            const delay = 1000; // 1 second

            while (attempts < maxAttempts) {
                await new Promise(resolve => setTimeout(resolve, delay));
                savedFilters = CommonStorage.getItems("filter-panel-" + Key) ? JSON.parse(CommonStorage.getItems("filter-panel-" + Key)) : null;
                if (savedFilters) {
                    const columns = originalColumns;
                    savedFilters = syncDateFilters([...savedFilters], columns);
                    break;
                }
                attempts++;
            }
        }

        const payload = {
            GridKey: Key,
            FilterDefinition: savedFilters ? JSON.stringify(savedFilters) : null,
            GridDefinition: GridDefinition ? GridDefinition : '',
            TemplateName: Name,
            Username: UserService.getUsername(),
            TemplateType: TemplateType,
            RecordId: "00000000-0000-0000-0000-000000000000",
            IsDefault: IsDefault
        };


        if (CommonStorage.getItems(Key + "-RecordID") && SaveType !== "New") {
            payload.RecordId = CommonStorage.getItems(Key + "-RecordID");
        }

        if (RecordID) payload.RecordId = RecordID;

        if (payload.FilterDefinition === null && GridDefinition === '') {
            // eslint-disable-next-line no-console
            console.log('No changes to save for key: ' + Key);
            return Promise.resolve({ message: 'No changes to save' });
        }
        return await this.saveToDataBase(payload, SaveType);
    },

    /*
    This function is responsible for sending the payload containing the grid and filter state to the database for saving. 
    It makes an API call to the ReportService to save the view variant, and handles the response to ensure that the RecordID is saved to local storage for future reference. 
    The function also includes error handling to log any issues that occur during the save process and to reject the promise with the error if the save operation fails.
    @param {object} payload - The data object containing the grid and filter state, template name, username, template type, and RecordID to be saved to the database
    */
    async saveToDataBase(payload, SaveType) {
        try {
            // eslint-disable-next-line no-unused-vars
            const saveResponse = await ReportService.saveViewVariant(payload);

            if (saveResponse && saveResponse.data) {
                if (saveResponse.data.RecordId) {
                    CommonStorage.saveItems(payload.Code + "-RecordID", saveResponse.data.RecordId);
                    saveResponse.data.RecordID = saveResponse.data.RecordId; // Ensure RecordID is available in the response for consistency
                }

                store.dispatch("gridViewDefinition/updateGridViewDefinition", {
                    key: payload.GridKey,
                    viewDefinition: saveResponse.data,
                });

                nextTick(() => {
                    if (SaveType === "New") {
                        store.dispatch("gridViewDefinition/setSelectedDefinition", {
                            key: payload.GridKey,
                            viewDefinition: saveResponse.data,
                        });
                    }
                });
            }

            return saveResponse;

        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('DB Error Saving REPORT', error);
            return Promise.reject(error);

        }
    },

    /*
    This function retrieves the grid view definition from the database for a given key. 
    It makes an API call to the ReportService to get the grid view definition based on the key and the current user's username, and returns the response. 
    The function includes error handling to reject the promise with the error if the retrieval operation fails.
    @param {string} key - The unique identifier for the grid view definition to be retrieved from the database
    */
    async getGridViewDefinitionFromDatabase(key) {
        try {
            const response = await ReportService.getGridViewDefinitionByKeyAndUsername(key);
            return Promise.resolve(response);
        } catch (error) {
            return Promise.reject(error);
        }
    },

    /*
    This function sets the selected template for a given grid key in the database.
    It makes an API call to the ReportService to set the selected template based on the grid key and the provided payload, and returns the response.
    The function includes error handling to reject the promise with the error if the operation fails.
    @param {string} gridKey - The unique identifier for the grid key
    @param {object} payload - The data object containing the template information to be set
    */
    async setSelectedTemplate(gridKey, payload) {
        try {
            const response = await ReportService.setSelectedTemplate(gridKey, payload);
            return Promise.resolve(response);
        } catch (error) {
            return Promise.reject(error);
        }
    },

    /*
    This function updates the definition "TemplateName" in the database for a given key and RecordID.
    It makes an API call to the ReportService to rename the view variant based on the key and the new template name, and returns the response.
    The function includes error handling to reject the promise with the error if the operation fails.
    @param {string} key - The unique identifier for the grid view definition to be updated in the database
    @param {string} newName - The new name for the template to be updated in the database
    */
    async renameDefinitionInDatabase(key, newName) {
        try {
            const response = await ReportService.renameViewVariant(key, {
                "TemplateName": newName
            });
            return Promise.resolve(response);
        } catch (error) {
            return Promise.reject(error);
        }
    },

    async deleteDefinitionFromDatabase(gridViewDefinitionId) {
        try {
            const response = await ReportService.deleteViewVariant(gridViewDefinitionId);
            return Promise.resolve(response);
        } catch (error) {
            return Promise.reject(error);
        }
    },

    // FROM POC - NOT IN USE
    async saveStateToDatabase(key, state, name) {

        const payload = {
            "Code": key,
            "Definition": state,
            "Name": name,
            "Username": UserService.getUsername(),
            "SaveType": "SaveForMe",
            RecordId: "00000000-0000-0000-0000-000000000000",
            FilterDefinition: CommonStorage.getItems("filter-panel-" + key) ? CommonStorage.getItems("filter-panel-" + key) : ''
        };

        if (CommonStorage.getItems(key + "-RecordID")) {
            payload.RecordId = CommonStorage.getItems(key + "-RecordID");
        }

        await this.saveToDataBase(payload);

    },
};





export { DataGridState };